module.exports = __webpack_public_path__ + "assets/e526ccaf3b0d0f37b9faa90dac003293.mp3";